// $(document).ready(function () {
//         let pincodeData = [];

//         // Function to load and parse CSV file
//         function loadPincodeData() {
//             $.ajax({
//                 url: "https://cdn.shopify.com/s/files/1/0685/2208/2526/files/PincodeTAT_Binary.csv?v=1718186309",
//                 method: "GET",
//                 dataType: "text",
//                 success: function (data) {
//                     // Parse CSV data
//                     const rows = data.split("\n");
//                     rows.forEach((row) => {
//                         const cols = row.split(","); // Split by commas
//                         const pincode = cols[0]?.trim(); // First column (pincode)
//                         if (pincode) {
//                             pincodeData.push(pincode);
//                         }
//                     });

//                     // Store pincode data in local storage
//                     localStorage.setItem("pincodeData", JSON.stringify(pincodeData));
//                     console.log("Pincode data loaded and stored in local storage.");
//                 },
//                 error: function () {
//                     console.error("Failed to load the pincode CSV file.");
//                 },
//             });
//         }

//         // Check if pincode data exists in local storage
//         const storedData = localStorage.getItem("pincodeData");
//         if (storedData) {
//             pincodeData = JSON.parse(storedData);
//             console.log("Pincode data loaded from local storage.");
//         } else {
//             loadPincodeData(); // Fetch and parse CSV if not in local storage
//         }

//         // Handle pincode check
//         $("#pincode_check").on("click", function (e) {
//             e.preventDefault();

//             const pincode = $("#pincode").val().trim();
//             const messageEl = $("#pincode_message");

//             // Reset message display
//             messageEl.hide().text("");

//             // Validate pincode (6 digits and numeric)
//             const pincodeRegex = /^[0-9]{6}$/;
//             if (!pincodeRegex.test(pincode)) {
//                 messageEl.text("Please enter a valid 6-digit pincode.").css("color", "red").show();
//                 return;
//             }

//             // Check pincode against loaded data
//             if (pincodeData.includes(pincode)) {
//                 messageEl.text("Delivery is available for this pincode.").css("color", "green").show();
//             } else {
//                 messageEl.text("Delivery is not available for this pincode.").css("color", "red").show();
//             }
//         });
//     });


$(document).ready(function () {
    // Handle pincode check
    $("#pincode_check").on("click", function (e) {
        e.preventDefault();

        const pincode = $("#pincode").val();
        const messageEl = $("#pincode_message");

        // Reset message display
        messageEl.hide().text("");

        // Validate pincode (6 digits and numeric)
        const pincodeRegex = /^[0-9]{6}$/;
        if (!pincodeRegex.test(pincode)) {
            messageEl.text("Please enter a valid 6-digit pincode.").css("color", "red").show();
            $('.main-btn').addClass('disabled');   // Disable the button
            $('.shopify-payment-button').addClass('disabled');
            $('.disabled').addClass('disabled');
            return;
        }
      const pincodes = parseInt(pincode, 10);
        // Make API call to check serviceability
        $.ajax({
            // url: "https://api.nuniverse.in/zydus/check/serviceability",
            url:"https://zydus.binaryic.in/api/pincode/serviceability",
            method: "POST",
            contentType: "application/json",
             headers: {
                'Content-Type': 'application/json',
                'x-api-key': 'NWZSUUH6gOajw6TetNRG62U9k2tyLbo58pVhRop1' // Updated key
            },
            data: JSON.stringify({ pincode: pincodes }),
            success: function (response) {
                // Assuming the API responds with a JSON object containing serviceability status
                if (response.prepaidServiceability === true) {
                  messageEl.text("Yay!! Delivery service is available at this pin code").css("color", "green").show();
                 $('.main-btn').removeClass('disabled', false);
                  $('.shopify-payment-button').removeClass('disabled', false);
                  $('.sticky-btn').removeClass('disabled');
                  // Enable the button
              } else if (response.prepaidServiceability === false) {
                  messageEl.text("Sorry!! Delivery service is not available at this pin code").css("color", "red").show();
                 $('.main-btn').addClass('disabled');   // Disable the button
                  $('.shopify-payment-button').addClass('disabled'); 
                  $('.sticky-btn').addClass('disabled');
              } else if (response.prepaidServiceability === null) {
                  messageEl.text("This pin code does not exist. Please check & enter the correct pin code").css("color", "red").show();
                  $('.main-btn').addClass('disabled');   // Disable the button
                  $('.shopify-payment-button').addClass('disabled'); 
                  $('.sticky-btn').addClass('disabled');
              }

                  
            },
            error: function () {
                messageEl.text("An error occurred while checking pincode serviceability.").css("color", "red").show();
            }
        });
    });
});
